export default {"src":"/_next/static/media/time.a60a6e5b.svg","height":18,"width":18};